import React, { useState, useEffect } from "react";
import { loadServiceItems } from "../../utils/helper-function"
import { ItemMenu } from "../../components/Service";
import Service from "../../models/Service";

const Laundry: React.FC = () => {
  const [laundries, setLaundries] = useState<Service[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const loadDrinks = async () => {
      const [laundries, categories] = await loadServiceItems("laundries");
      setLaundries(laundries);
      setCategories(categories);
    };
    loadDrinks();
  }, []);

  return (
    <ItemMenu title="Laundries" items={laundries} categories={categories} />
  );
};

export default Laundry;
